;(function () {

    var SendMistake = ({
        url:  window.location.origin + '/sendmistake',
        init: function () {

            if ('vgtrkFormWidgets' in window && vgtrkFormWidgets['vgtrk-widget-id-561']) {
                vgtrkFormWidgets['vgtrk-widget-id-561'].$children[0].externalData = {
                    correction_page_url: window.opener.location.href,
                    correction_error:    window.opener.getSelection().toString()
                };
            } else {
                this.bind();
            }
        },
        bind: function () {
            var sendMistake = this;

            document.addEventListener('keyup', function (event) {
                if (event && event.ctrlKey && event.key === 'Enter') {
                    setTimeout(function () {
                        sendMistake.open();
                    }, 250);

                }
            })
        },
        open: function () {
            var modal = window.open(this.url, 'Send mistake');

            window.blur();
            modal.focus();
        }
    }).init();

}());


